import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@outboundTexting/"

const postBulkSMSObj = makePieActionObjs("post", "BulkSMS")
const loadBulkSMSObj = makePieActionObjs("load", "BulkSMS")
const getEstimatedCountObj = makePieActionObjs("get", "estimatedCount")
const loadInitialRecipientsObj = makePieActionObjs("load", "BulkSMS_initial_recipients")

export const postBulkSMSActionDict = prependAppName(appName, postBulkSMSObj.pieDict)
export const getEstimatedCountActionDict = prependAppName(appName, getEstimatedCountObj.pieDict)
export const loadInitialRecipientsActionDict = prependAppName(appName, loadInitialRecipientsObj.pieDict)

const actionTypes = prependAppName(appName, {
    ...loadBulkSMSObj.actionTypes,
    ...postBulkSMSObj.actionTypes,
    ...getEstimatedCountObj.actionTypes,
    ...loadInitialRecipientsActionDict.actionTypes,
})

export default actionTypes
